import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import useMakeRequest from "../../utils/ApiHelper";
import { ApiConstants } from "../../constants/ApiConstants";
import FrontLoader from "./FrontLoader";
import { socket } from "../../utils/Socket";
import { LanguageConstants } from "../../constants/LanguageConstants";
import {
  clearStripeCheckoutSessionId,
  getStripeSessionIdFromSearch,
} from "../../utils/stripeCheckout";
import { QUOTE_SUCCESS_LOGO_URL } from "../../utils/quoteSuccessLogo";
import "./OrderSuccess.scss";

function Success() {
  const PaymentStatus = useMakeRequest();
  const navigate = useNavigate();
  const loaction = useLocation();
  const paymentId = getStripeSessionIdFromSearch(loaction.search);
  const isWireTransferSuccess =
    new URLSearchParams(loaction.search).get("wire") === "1";
  const wireSuccessDescription =
    LanguageConstants?.ORDER_SUCCESS_WIRE_DESC ??
    "An email has been sent with the information to make the payment via wire transfer. Once we receive the funds we will proceed with your order.";
  const successDescription = isWireTransferSuccess
    ? wireSuccessDescription
    : LanguageConstants?.ORDER_SUCCESS_DESC;

  const handleNavigateHome = () => {
    navigate("/");
  };

  useEffect(() => {
    if (paymentId) {
      clearStripeCheckoutSessionId();
      const payload = {
        type: "web",
        payment_type: 0,
        paymeny_status: "success",
        payment_id: paymentId,
      };
      const socketpayload = {
        sender_type: "1",
        receiver_id: "1",
      };
      socket.emit("admin_count", socketpayload, async (_response: unknown) => {});
      PaymentStatus.makeRequest({
        payload,
        url: ApiConstants?.OrderStatus,
        toastStatus: false,
      });
    }
  }, []);

  return (
    <>
      {PaymentStatus.loading ? <FrontLoader /> : null}
      <div className="order-success-page" role="dialog" aria-labelledby="order-success-title">
        <div className="order-success-page__card">
          <img
            src={QUOTE_SUCCESS_LOGO_URL}
            alt="Quote N Buy"
            className="order-success-page__logo"
            width={128}
            height={128}
            decoding="async"
          />
          <h1 className="order-success-page__title" id="order-success-title">
            {LanguageConstants?.ORDER_SUCCESS_TITLE}
          </h1>
          <p className="order-success-page__desc">{successDescription}</p>
          <div className="order-success-page__actions">
            <button
              type="button"
              className="order-success-page__homeBtn"
              onClick={handleNavigateHome}
            >
              {LanguageConstants?.HOME}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default Success;
